import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Switch } from "../ui/switch";
import TemplateEditor, { ACK_EVENTS, STATUS_EVENTS } from "./TemplateEditor";
import InboxClientOverrides from "./InboxClientOverrides";

/** Requester e-mails for the inbox: acknowledgements (new / update / job), status updates (scheduled / on the way /
 *  completed) and per-client wording. Values live in the parent settings object `s`. */
export default function InboxAckSettings({ s, setS }) {
  const patch = (p) => setS({ ...s, ...p });
  return (
    <>
      <div className="rounded-md border border-border p-3 space-y-3" data-testid="inbox-ack-settings">
        <div className="flex items-start justify-between gap-3">
          <div><p className="text-sm font-medium">Client acknowledgement emails</p><p className="text-xs text-muted-foreground">Automatic replies to the sender when their email becomes a request, when a reply is added to it, and when it's turned into a job. Sent from the sender SMTP above (or your email-sending mailbox) with the request reference in the subject, so their replies thread straight back onto the request.</p></div>
          <Switch checked={!!s.ack_enabled} onCheckedChange={(v) => patch({ ack_enabled: v })} data-testid="inbox-ack-enabled" />
        </div>
        {s.ack_enabled && (
          <>
            <div className="sm:w-64"><Label className="text-xs">We aim to respond within</Label><Input value={s.ack_response_time || ""} onChange={(e) => patch({ ack_response_time: e.target.value })} placeholder="one working day" className="h-8 text-xs" data-testid="inbox-ack-response-time" /></div>
            <TemplateEditor events={ACK_EVENTS} values={s} onChange={patch} testid="inbox-ack" />
          </>
        )}
      </div>
      <div className="rounded-md border border-border p-3 space-y-3" data-testid="inbox-status-settings">
        <div className="flex items-start justify-between gap-3">
          <div><p className="text-sm font-medium">Status update emails</p><p className="text-xs text-muted-foreground">Short emails to the person who raised the request — only for jobs that came in through this inbox — when the visit is booked, when the engineer sets off, and when the work is done. The client's main contact still gets the standard completion email.</p></div>
          <Switch checked={s.status_enabled !== false} onCheckedChange={(v) => patch({ status_enabled: v })} data-testid="inbox-status-enabled" />
        </div>
        {s.status_enabled !== false && <TemplateEditor events={STATUS_EVENTS} values={s} onChange={patch} testid="inbox-status" />}
      </div>
      <InboxClientOverrides />
    </>
  );
}
